// reducers/employee-onboarding/deny.js

export function denyHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_DENY_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function denyIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_DENY_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function deny(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_DENY_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}